// extracted by mini-css-extract-plugin
export default {"root":"AboutContainer_root__E0-ky","back":"AboutContainer_back__LDwn1","title":"AboutContainer_title__rW5Ft","text":"AboutContainer_text__sHrV7","sign":"AboutContainer_sign__f+cR5"};